import { Icon } from 'semantic-ui-react';

import commonPropTypes from 'utils/commonPropTypes';

import * as svars from 'assets/style/variables';

const sentimentIconStepSpacePx = 4;
function SentimentIcon({ style }) {
  return (
    <Icon.Group
      style={{
        display: 'inline-table',
        minWidth: '15px',
        ...style,
      }}
    >
      <Icon
        name="map pin"
        style={{
          marginLeft: 0,
          marginRight: 0,
          color: svars.absoluteMinColor,
          width: 'auto',
        }}
      />
      <Icon
        name="map pin"
        style={{
          marginLeft: `${sentimentIconStepSpacePx}px`,
          left: '28%',
          width: 'auto',
          color: svars.absoluteMidColor,
        }}
      />
      <Icon
        name="map pin"
        style={{
          left: '30%',
          width: 'auto',
          marginLeft: `${2 * sentimentIconStepSpacePx}px`,
          color: svars.absoluteMaxColor,
        }}
      />
    </Icon.Group>
  );
}

SentimentIcon.propTypes = {
  style: commonPropTypes.style,
};
SentimentIcon.defaultProps = {
  style: {},
};

function PositiveNegativePointFactory(isPositive) {
  function PositiveNegativePoint({ style }) {
    return (
      <Icon
        style={{
          color: isPositive ? svars.absoluteMaxColor : svars.absoluteMinColor,
          paddingTop: 0,
          fontSize: svars.fontSizeMedium,
          verticalAlign: 'middle',
          ...style,
        }}
        name={`${isPositive ? 'plus' : 'minus'} circle`}
        size={null}
      />
    );
  }
  PositiveNegativePoint.propTypes = {
    style: commonPropTypes.style,
  };
  PositiveNegativePoint.defaultProps = {
    style: {},
  };
  return PositiveNegativePoint;
}

export const PositivePoint = PositiveNegativePointFactory(true);
export const NegativePoint = PositiveNegativePointFactory(false);

export default SentimentIcon;
